'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactRouter = require('react-router');
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _isArray2 = require('lodash/isArray');var _isArray3 = _interopRequireDefault(_isArray2);
var _isEqual = require('lodash/isEqual');var _isEqual2 = _interopRequireDefault(_isEqual);


var _components = require('../../components');

var _constants = require('../../constants');




var _beautifyNumber = require('../../helpers/beautifyNumber');var _beautifyNumber2 = _interopRequireDefault(_beautifyNumber);
var _clearNumber = require('../../helpers/clearNumber');var _clearNumber2 = _interopRequireDefault(_clearNumber);
var _routerAdapter = require('../../helpers/routerAdapter');
var _checkAdvancedFiltersQuantity = require('../../helpers/checkAdvancedFiltersQuantity');var _checkAdvancedFiltersQuantity2 = _interopRequireDefault(_checkAdvancedFiltersQuantity);
var _analyticsManager = require('../../utils/analytics/analyticsManager');
var _analyticsConstants = require('../../utils/analytics/analyticsConstants');
var _formatPropertyTypes = require('../../utils/formatPropertyTypes');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
var LineFilterContainer = function (_Component) {_inherits(LineFilterContainer, _Component);function LineFilterContainer(props) {_classCallCheck(this, LineFilterContainer);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);var _props$routeData =
    props.routeData,optionType = _props$routeData.optionType,_props$routeData$para = _props$routeData.params,rooms = _props$routeData$para.rooms,types = _props$routeData$para.types,price = _props$routeData$para.price,status = _props$routeData$para.status;
    var location = (0, _get2.default)(props, 'routeData.location') || _constants.sections.homes.location;

    _this.state = {
      propertyTypes: _this.formatPropertyTypes(optionType, location),
      rooms: rooms || ['all'],
      optionType: optionType,
      types: types || ['all'],
      status: status || ['all'],
      price: price,
      advancedFiltersQuantity: (0, _checkAdvancedFiltersQuantity2.default)(props.routeData.params) };return _this;

  }LineFilterContainer.prototype.

  componentWillReceiveProps = function componentWillReceiveProps(newProps) {var
    price = newProps.routeData.params.price;
    var stateModifier = {};var
    minPrice = price.minPrice,maxPrice = price.maxPrice;

    if (minPrice !== this.state.price.minPrice || maxPrice !== this.state.price.maxPrice) {
      stateModifier.price = price;
    }

    if (newProps.routeData) {
      var isLocationChanged = this.props.routeData.location !== newProps.routeData.location;
      var isOptionTypeChanged = this.props.routeData.optionType !== newProps.routeData.optionType;

      if (isLocationChanged || isOptionTypeChanged) {var _newProps$routeData =
        newProps.routeData,optionType = _newProps$routeData.optionType,location = _newProps$routeData.location;
        stateModifier.optionType = optionType;

        stateModifier.propertyTypes = this.formatPropertyTypes(optionType, location);
      }

      if (isLocationChanged) {
        stateModifier.types = ['all'];
        stateModifier.rooms = ['all'];
      }
    }

    var withPrice = window && window.innerWidth < 1180;
    stateModifier.advancedFiltersQuantity = (0, _checkAdvancedFiltersQuantity2.default)(newProps.routeData.params, withPrice);
    this.setState(stateModifier);
  };LineFilterContainer.prototype.

  shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.locale !== nextProps.locale || !(0, _isEqual2.default)(this.props.routeData, nextProps.routeData);
  };LineFilterContainer.prototype.



























































































































  render = function render() {var _state =
    this.state,types = _state.types,status = _state.status,rooms = _state.rooms,advancedFiltersQuantity = _state.advancedFiltersQuantity;var
    location = this.props.routeData.location;
    var roomsValues = rooms.map(function (item) {return typeof item === 'number' ? item.toString() : item;});

    return location === 'projects' ?

    _react2.default.createElement(_components.LineFiltersProjects, {
      handleChange: this.handleChange,
      formatPriceParameters: this.formatPriceParameters,
      translate: this.props.translate,
      propertyTypes: this.state.propertyTypes,
      types: types,
      status: status,
      locale: this.props.locale,
      rooms: roomsValues }) :



    _react2.default.createElement(_components.LineFiltersHomes, {
      handleChange: this.handleChange,
      formatPriceParameters: this.formatPriceParameters,
      handleOpenAdvancedFilters: this.handleOpenAdvancedFilters,
      setFavoritesListState: this.props.setFavoritesListState,
      saveSearchLocation: this.props.saveSearchLocation,
      translate: this.props.translate,
      locale: this.props.locale,
      favoritesListIsActive: this.props.favoritesListIsActive,
      optionType: this.props.routeData.optionType,
      propertyTypes: this.state.propertyTypes,
      types: types,
      rooms: roomsValues,
      advancedFiltersQuantity: advancedFiltersQuantity,
      isCommercial: location === 'commercial' });


  };return LineFilterContainer;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this2 = this;this.filterParams = function (newParams) {var params = { price: { maxPrice: '' }, types: '', status: '', rooms: '' };var _loop = function _loop(key) {var getValue = function getValue() {switch (key) {case 'rooms':return newParams[key].length > 0 && newParams[key][0] !== 'all' ? newParams[key].sort().map(function (item) {return +item;}) : null;case 'types':case 'status':return newParams[key].length > 0 && newParams[key][0] !== 'all' ? newParams[key] : null;default:return newParams[key];}};var value = getValue();var hasArrValues = (0, _isArray3.default)(value);var isBool = typeof value === 'boolean';var hasPrice = key === 'price' && value && (value.minPrice || value.maxPrice);var ignored = key === 'propertyTypes';var hasTypes = key === 'types' && value;var hasStatuses = key === 'status' && value;if (!ignored && hasArrValues || isBool || hasPrice || hasTypes || hasStatuses) {params[key] = value;}};for (var _iterator = Object.keys(newParams), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {var _ref;if (_isArray) {if (_i >= _iterator.length) break;_ref = _iterator[_i++];} else {_i = _iterator.next();if (_i.done) break;_ref = _i.value;}var key = _ref;_loop(key);}return params;};this.updateRoute = function (type, newParams) {var _props$routeData2 = _this2.props.routeData,pointCoordinates = _props$routeData2.pointCoordinates,drawnPoly = _props$routeData2.drawnPoly,location = _props$routeData2.location;var optionType = type || _this2.props.routeData.optionType;var data = type || type === null && location === 'projects' ? { optionType: optionType, pointCoordinates: pointCoordinates, drawnPoly: drawnPoly, params: Object.assign({}, _this2.props.routeData.params, _this2.filterParams(newParams)) } : Object.assign({}, _constants.clearFiltersInitialValues, { locationSearch: Object.assign({}, _this2.props.routeData.locationSearch) });var filteredCommodities = data.optionType === 'buy' && data.params.commodities && data.params.commodities.filter(function (item) {return item !== 'roommates';});if (filteredCommodities) {data.params.commodities = filteredCommodities;}var routeData = Object.assign({}, _this2.props.routeData, { firstLoad: false }, data);var route = (0, _routerAdapter.createUrl)(routeData);if (route === _this2.props.routeData.route) {return;}if (!type && location !== 'projects') {_this2.setState(Object.assign({}, _constants.propertyFiltersInitialValues));}_reactRouter.browserHistory.push({ pathname: route, state: routeData });};this.formatPropertyTypes = function (optionType, location) {var section = (0, _get2.default)(_constants.sections, location + '.value');if (location === 'projects') {return (0, _formatPropertyTypes.unitePropertyTypesBySections)(_this2.props.propertyTypes);}return (0, _get2.default)(_this2.props, 'propertyTypes.' + section + '.' + optionType) || [];};this.handleChange = function (field, value) {var _this2$setState, _Object$assign;_this2.setState((_this2$setState = {}, _this2$setState[field] = value, _this2$setState));var nextState = Object.assign({}, _this2.state, (_Object$assign = {}, _Object$assign[field] = value, _Object$assign));_this2.updateRoute(nextState.optionType, nextState);_this2.forceUpdate();};this.clearAllFilters = function () {return _this2.updateRoute();};this.formatPriceParameters = function (field) {return { value: (0, _beautifyNumber2.default)(_this2.state.price[field]), onChange: function onChange(value) {var _Object$assign2;return _this2.handleChange('price', Object.assign({}, _this2.state.price, (_Object$assign2 = {}, _Object$assign2[field] = (0, _clearNumber2.default)(value), _Object$assign2)));} };};this.handleOpenAdvancedFilters = function () {// analytics
    (0, _analyticsManager.trackEvent)(_analyticsConstants.eventCategory.searchResults, _analyticsConstants.eventAction.open, _analyticsConstants.eventLabel.advancedFilter);_this2.props.openAdvancedFilters();};};

LineFilterContainer.propTypes = {
  locale: _propTypes2.default.string.isRequired,
  translate: _propTypes2.default.func.isRequired,
  routeData: _propTypes2.default.object.isRequired,
  propertyTypes: _propTypes2.default.object,
  openAdvancedFilters: _propTypes2.default.func.isRequired,
  saveSearchLocation: _propTypes2.default.func.isRequired,
  favoritesListIsActive: _propTypes2.default.bool,
  setFavoritesListState: _propTypes2.default.func.isRequired };exports.default =


LineFilterContainer;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LineFilterContainer/LineFilterContainer.js
// module id = 2983
// module chunks = 0